import ApiService from '../apiservice'

export default class GrupoAtividadeTituloService extends ApiService {

  constructor() {
    super('/grupo-atividade-titulo')
  }

	adicionar(gat) {
		return this.post('/',gat);
	}

	consultarPorGrupo(grupoId) {
		return this.get(`/consultar-titulos/${grupoId}`);
	}

	alterar(request) {
		return this.put('/',request);
	}

	excluir(tituloId,grupoId) {
		return this.delete(`/${tituloId}/${grupoId}`);
	}
}